export default function coreController(
    $scope,
    $rootScope,
    $route,
    siteService,
    $timeout,
    houseService,
    ENV,
    Users,
    Basket
) {
    // Empty basket (localstorage) if new user signs in
    // if (Users.getUserSwitchDetected()) {
    //     Basket.resetBasket();
    //     Users.setUserSwitchDetected(false);
    // } else {
    //     Basket.init();
    // }

    Basket.init();

    // INIT THE BASKET (localstorage)

    // $document.on('scroll', function() {
    //   console.log('Document scrolled to ', $document.scrollLeft(), $document.scrollTop());
    // });
    // var container = angular.element(document.getElementById('container'));
    // container.on('scroll', function() {
    //   console.log('Container scrolled to ', container.scrollLeft(), container.scrollTop());
    // });

    // $rootScope.$on("cfpLoadingBar:completed", function (event) {
    //     $scope.showReloadButton = false;
    //     $timeout.cancel(timer);
    // });

    /*******************************
     *  LOGIN MODAL
     ********************************/

    // // When user mobile - aside right -> Recieve Broadcast from Searchbar.js -> houseService
    // $scope.$on("show-login-modal-broadcast", function () {
    //     console.log("show-login-modal-broadcast");

    //     $scope.showLoginModal();
    // });

    $scope.focusSearchBar = function () {
        $("#search-activity").focus();
    };

    $scope.showLoginModal = function () {
        // FIXES : http://stackoverflow.com/questions/19305821/multiple-modals-overlay
        // Just provide a template url, a controller and call 'showModal'.
        // ModalService.showModal({
        //     template: require("../components/modals/login/template.html"),
        //     controller: "loginModal",
        //     inputs: {},
        // }).then(function (modal) {
        //     // The modal object has the element built, if this is a bootstrap modal
        //     // you can call 'modal' to show it, if it's a custom modal just show or hide
        //     // it as you need to.
        //     console.log(modal);
        //     modal.element.modal();
        //     modal.close
        //         .then(function (modalArgs) {
        //             console.log(modalArgs);
        //             if (modalArgs.action == "redirect") {
        //                 $location.path(modalArgs.location);
        //             }
        //             if (modalArgs.action == "booknow") {
        //                 Bookings.initBooking();
        //             }
        //         })
        //         .catch(function (error) {
        //             // error contains a detailed error message.
        //             console.log(error);
        //         });
        // });
    };

    /**
     * INIT SERVICES VARS
     */

    houseService.searchFilter.startDate =
        houseService.calenderFilter.startDate();

    // LAZY LOAD
    // If you need to run the image check manually (for example when clicking on tabs that filter your image result), you can trigger it that way:
    // $rootScope.$emit('lazyImg:refresh');

    // var oBodyClasses = {
    //     breakpoint: "md",
    //     deviceMode: "desktop",
    //     heroMode: "", //has-hero-mobile / has-hero-desktop
    // };

    /**
     * Breakpoints / body class
     * @param  {obj}        event                      [ event listener obj]
     * @param  string       currentBreakpoint           [Recieves the current Bootstrap breakpoint]
     * @param  string       previousBreakpoint         [ previous Breakpoint ]
     * @return void
     */
    var windowResizeEventListener = $rootScope.$on(
        "windowResize",
        function (event, currentBreakpoint) {
            // avail params : event, currentBreakpoint, previousBreakpoint
            $scope.currentBreakpoint = siteService.currentBreakpoint =
                currentBreakpoint;

            $scope.setDeviceModeBodyClass(currentBreakpoint);

            siteService.addBodyClass(currentBreakpoint, "breakpoint");
        }
    );
    $scope.$on("$destroy", windowResizeEventListener);

    var routeChangeSuccessEventListener = $rootScope.$on(
        "$routeChangeSuccess",
        function () {
            //avail params : event, currentRoute
            $scope.setDeviceModeBodyClass(null);
        }
    );
    $scope.$on("$destroy", routeChangeSuccessEventListener);

    var addBodyClassEventListener = $rootScope.$on(
        "addBodyClass",
        function (event, classToAdd, prop) {
            siteService.addBodyClass(classToAdd, prop);
        }
    );
    $scope.$on("$destroy", addBodyClassEventListener);

    // siteService.addBodyClass = function (classToAdd, prop) {
    //     oBodyClasses[prop] = classToAdd;

    //     var aBodyClasses = [];

    //     for (var property in oBodyClasses) {
    //         if (oBodyClasses.hasOwnProperty(property)) {
    //             // do stuff
    //             aBodyClasses.push(oBodyClasses[property]);
    //         }
    //     }

    //     $scope.bodyClasses = aBodyClasses.join(" ");
    // };

    // Add class to body elem - used by css
    $scope.setHeroBodyClass = function (classToAdd, prop) {
        if (classToAdd == "has-hero-desktop") {
            if ($route.current.$$route.hasHeroDesktop) {
                siteService.addBodyClass(classToAdd, prop);
            } else {
                siteService.addBodyClass("", prop);
            }
        }

        if (classToAdd == "has-hero-mobile") {
            if ($route.current.$$route.hasHeroMobile) {
                siteService.addBodyClass(classToAdd, prop);
            } else {
                siteService.addBodyClass("", prop);
            }
        }
    };

    $scope.setDeviceModeBodyClass = function (currentBreakpoint) {
        let deviceMode;
        let headerHeight;
        let desktopHeaderBreakponts = ["md", "lg"];
        let mobileHeaderBreakponts = ["xxs", "xs", "sm"];

        if (!currentBreakpoint) {
            currentBreakpoint = siteService.currentBreakpoint;
        }

        if (desktopHeaderBreakponts.indexOf(currentBreakpoint) != -1) {
            deviceMode = "desktop";
            headerHeight = ENV.enableDevBar ? 132 : 100;
            $scope.setHeroBodyClass("has-hero-desktop", "heroMode");
        }

        if (mobileHeaderBreakponts.indexOf(currentBreakpoint) != -1) {
            deviceMode = "mobile";
            headerHeight = ENV.enableDevBar ? 92 : 60;
            $scope.setHeroBodyClass("has-hero-mobile", "heroMode");
        }

        siteService.addBodyClass(deviceMode, "deviceMode");

        setTimeout(function () {
            $scope.$apply(function () {
                $scope.devicemode = siteService.deviceMode = deviceMode;
                siteService.headerHeight = headerHeight;
                $scope.bodyClasses = siteService.bodyClasses;
            });
        });
    };
}
